import type { SignDocument } from "../Models/Domain";

import useSignDocuments from "../Store";

import { cancel } from "@/Services/TherapyApi/SignDocuments";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import SignDocumentTransformer from "@/Modules/Transformers/SignDocument";

import { hasValue } from "@/Utils/Objects";

async function RejectDocumentActionHandler(uuid: string): Promise<SignDocument | undefined> {
  const signDocumentsStore = useSignDocuments();

  signDocumentsStore.isLoading = true;

  const resp = await cancel(uuid).catch(() => undefined);

  if (isApiError(resp) || !hasValue(resp)) {
    return undefined;
  }

  return SignDocumentTransformer.toDomain(resp);
}

export default RejectDocumentActionHandler;
